import React, { useMemo } from "react";
import { Descriptions, List, Skeleton, Button, Popover, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const InvoiceDetails = ({ loading, invoice, applications, handleRemoveApplication }) => {
    const invoiceApplicationIds = useMemo(() => invoice?.applications?.map(app => app.application._id) || [], [invoice]);
    const filteredApplications = useMemo(() => applications.filter(app => invoiceApplicationIds.includes(app._id) && app.paid === false), [applications, invoiceApplicationIds]);

    return (
        <Descriptions
            title="Event details"
            bordered
            size="small"
            loading={loading}
            layout="vertical"
        >
            <Descriptions.Item label="Events">
                {loading ? (
                    <Skeleton active paragraph={{ rows: 3 }} />
                ) : (
                    filteredApplications.length > 0 ? (
                        <List
                            size="small"
                            dataSource={filteredApplications}
                            renderItem={(item) => {
                                const eventName = item?.event?.name ?? "Unknown Event";
                                const eventStyle = item?.event?.style ?? "Unknown Style";
                                const groupName = item?.group?.group_name ?? "Unknown Group";
                                const isSolo = item?.event?.solo_bool ?? false;
                                return (
                                    <List.Item
                                    actions={!invoice?.paid ? [  
                                        <Popover  
                                            content={(  
                                                <div>  
                                                    <p>Are you sure you want to remove this application?</p>  
                                                    <p>This action cannot be undone.</p>  
                                                    <Button type="primary" onClick={() => handleRemoveApplication(item._id)}>Yes</Button>  
                                                    <Button onClick={(e) => e.stopPropagation()}>No</Button>  
                                                </div>  
                                            )}  
                                            title="Confirm Removal"  
                                            trigger="click"  
                                        >  
                                            <Button  
                                                type="text"  
                                                icon={<CloseOutlined />}  
                                            />  
                                        </Popover>  
                                    ] : null}  
                                    >
                                        <List.Item.Meta
                                            title={eventName}
                                            description={`${eventStyle} (${isSolo ? 'Solo' : `Group - ${groupName}`})`}
                                        />
                                    </List.Item>
                                );
                            }}
                        />
                    ) : (
                        <div>No applications available.</div>
                    )
                )}
            </Descriptions.Item>
        </Descriptions>
    );
};

export default InvoiceDetails;  
